import { useState } from "react";
import foto from "../../image/Portafolio.png";
import "./Portafo.css";
import LogoCss from "../../image/css.png";
import LogoReact from "../../image/react.png";
import LogoBoostraReack from "../../image/react-bootstrap.png";
import logoSemantic from "../../image/semantic.png";
import LogoRedux from "../../image/Redux.png";
import LogoGitHum from "../../image/logo-GitHub-500x281.png";
import iconojava from "../../image/iconojava.png";
import iconospring from "../../image/spring.png";


const Portafo = () => {
  const { mover, SetMover } = useState(false);

  return (
    <form>
      <div class="input-group mb-3 inicioPorta">
        <span class="imagen input-group-text " id="basic-addon2">
          <img src={foto} alt="foto" onClick={() => SetMover()} />
        </span>

        <article class="form-control">
          I am a Full Stack Developer passionate about creating high-performance
          applications with a well-organized architecture. Also with the ability
          to work under pressure and in a team, I have experience in the fields
          of human resources, product design and customer relationship.
          <figure className="Logos">
          <img src={iconojava} alt="foto" onClick={() => SetMover()} />
          <img src={iconospring} alt="foto" onClick={() => SetMover()} />
            <img src={LogoReact} alt="foto" onClick={() => SetMover()} />
            <img src={LogoCss} alt="foto" onClick={() => SetMover()} />
            <img src={LogoBoostraReack} alt="foto" onClick={() => SetMover()} />
            <img src={logoSemantic} alt="foto" onClick={() => SetMover()} />
            <img src={LogoRedux} alt="foto" onClick={() => SetMover()} />
            <figure className="Logos2">
              <img src={LogoGitHum} alt="foto" onClick={() => SetMover()} />
              <a href="https://github.com/Jaime-U-Lopez">Link GitHub</a>
            </figure>
          </figure>
        </article>
      </div>
    </form>
  );
};

export default Portafo;
